import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  message: string[] = [];

  /**
   *TO IMPLEMENT:
   *Add passed in message to the stored message queue
   * @param {string} message
   * @memberof ErrorMessageService
   */
  add(message: string) {
    this.message.push(message);
  }

  /**
   *TO IMPLEMENT:
   *Clear the error message queue
   * @memberof ErrorMessageService
   */
  clear() {
    this.message = [];
  }
}
